import * as React from 'react';
import { cn } from '@/lib/utils';
import styles from './alert.module.css';

const VARIANT_CLASS = {
  default: styles.variantDefault,
  success: styles.variantSuccess,
  warning: styles.variantWarning,
  destructive: styles.variantDestructive,
  info: styles.variantInfo,
} as const;

export type AlertVariant = keyof typeof VARIANT_CLASS;

/** Alert class string, for elements other than `Alert` that must look like one. */
function alertVariants({ variant }: { variant?: AlertVariant | null } = {}): string {
  return cn(styles.root, VARIANT_CLASS[variant ?? 'default']);
}

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant | null;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(({ className, variant, ...props }, ref) => (
  <div ref={ref} className={cn(alertVariants({ variant }), className)} {...props} />
));
Alert.displayName = 'Alert';

export { Alert, alertVariants };
